<script setup lang="ts">
import { Icon as OriginalNuxtIcon } from "#components";
defineOptions({
  name: "BaseIcon",
});
const props = defineProps<{ name: string }>();
if (import.meta.env.DEV) {
  const _i = getCurrentInstance();
  const ALLOWED_ICON_SETS = ["mdi", "ic", "fa6-solid", "fa6-regular"];
  const prefix = props.name.split(":")[0];
  if (prefix && !ALLOWED_ICON_SETS.includes(prefix)) {
    devConsole.warn(
      `Please adjust from using the "${props.name}" icon to using one from the following sets: "${ALLOWED_ICON_SETS.join('", "')}"`,
    );
    devConsole.groupCollapsed("Component Stack");
    let current = _i;
    while (current) {
      devConsole.log(`<${current.type.displayName ?? current.type.name ?? "Anonymous"} />`, { ...current });
      if (current !== current.parent) {
        current = current.parent;
      }
    }

    devConsole.groupEnd();
  }
}
</script>
<template>
  <original-nuxt-icon :name v-bind="$attrs" role="img" />
</template>

<style scoped lang="postcss"></style>
